export class OrderStaticData {
    public static readonly MEDIUM_HOUSE_UNIT_AMOUNT = 1;
    public static readonly LARGE_HOUSE_UNIT_AMOUNT = 2;
    public static readonly SINGLE_UNIT_AMOUNT = 1;
    public static readonly EXTRA_UNIT_AMOUNT = 1;
    public static readonly HOME_GATEWAY_UPGRADE_AMOUNT: number = 1;
}
